module.exports = __webpack_public_path__ + "images/home/product/video-bg-2fc6a8438baa0bbf65094e60691fc461.png";